<template>
  <div class="header">
    <div class="left">
      <div @click="gotoHome()" class="logo">
        <img
          src="@/assets/image/login/logo.png"
          alt="logo">
      </div>
      <div class="area">
        <NavList v-if="userInfo.EMP_SID != '' && !serviceMode" />
        <ToggleLang />
        <ToggleUser v-if="!serviceMode"/>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    // 服务协议页面标识
    serviceMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },
  mounted () {
  },
  methods: {
    gotoHome () {
      this.$router.push({
        name: 'Home'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  min-width: 1360px;
  height: 64px;
  background: #060432;
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1 1 0%;
    padding: 0 60px;
    .logo {
      width: 136px;
      height: 36px;
      cursor: pointer;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .area {
      display: flex;
      align-items: center;
      height: 100%;
      .text {
        margin-right: 50px;
        .tip-text();
      }
    }
  }
}
</style>
